import { render } from "./FinancesTabs.vue?vue&type=template&id=7534d656"
import script from "./finances-tabs-component.ts?vue&type=script&lang=js&external"
export * from "./finances-tabs-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__